import { useTranslation } from 'react-i18next'

import { getNoveltyIconByType } from '../../lib'
import { Document, UserSessionType } from '../../types'

const DocumentFindingsGeneralDetails = ({ userSession, documentData }: { userSession: UserSessionType; documentData: Partial<Document> }) => {
  const { t } = useTranslation(['document-details-management'])

  return (
    <div className="document-details-findings-container">
      <div className="document-details-findings-title">{t('documentFindingsGeneralDetails.subtitle')}</div>
      {Number(documentData.totalOfNoveltiesReviewed) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['reviewed']}
              alt="reviewed-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesReviewed) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesReviewed)} ${t('documentFindingsGeneralDetailsSingular.reviewed')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesReviewed)} ${t('documentFindingsGeneralDetails.reviewed')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesRejected) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['rejected']}
              alt="rejected-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesRejected) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesRejected)} ${t('documentFindingsGeneralDetailsSingular.rejected')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesRejected)} ${t('documentFindingsGeneralDetails.rejected')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyBankName) > 0 && userSession.role.indexOf('-client') === -1 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-bank-name']}
              alt="empty-bank-data-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyBankName) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankName)} ${t('documentFindingsGeneralDetailsSingular.emptyBankName')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankName)} ${t('documentFindingsGeneralDetails.emptyBankName')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyBankName) > 0 && userSession.role.indexOf('-client') > -1 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-bank-code']}
              alt="empty-bank-data-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyBankName) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankName)} ${t('documentFindingsGeneralDetailsSingular.emptyBankCode')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankName)} ${t('documentFindingsGeneralDetails.emptyBankCode')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesUnknownBankName) > 0 && userSession.role.indexOf('-client') === -1 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['unknown-bank-name']}
              alt="warning-bank-data-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesUnknownBankName) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesUnknownBankName)} ${t('documentFindingsGeneralDetailsSingular.unknownBankName')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesUnknownBankName)} ${t('documentFindingsGeneralDetails.unknownBankName')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesUnknownBankName) > 0 && userSession.role.indexOf('-client') > -1 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['unknown-bank-code']}
              alt="warning-bank-data-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesUnknownBankName) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesUnknownBankName)} ${t('documentFindingsGeneralDetailsSingular.unknownBankCode')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesUnknownBankName)} ${t('documentFindingsGeneralDetails.unknownBankCode')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyBankAccountNumber) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-bank-account-number']}
              alt="warning-bank-account-number-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyBankAccountNumber) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankAccountNumber)} ${t('documentFindingsGeneralDetailsSingular.emptyBankAccountNumber')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankAccountNumber)} ${t('documentFindingsGeneralDetails.emptyBankAccountNumber')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyBankAccountType) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-bank-account-type']}
              alt="empty-bank-account-type-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyBankAccountType) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankAccountType)} ${t('documentFindingsGeneralDetailsSingular.emptyBankAccountType')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyBankAccountType)} ${t('documentFindingsGeneralDetails.emptyBankAccountType')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesWrongBankAccountType) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['wrong-bank-account-type']}
              alt="wrong-bank-account-type-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesWrongBankAccountType) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongBankAccountType)} ${t('documentFindingsGeneralDetailsSingular.wrongBankAccountType')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongBankAccountType)} ${t('documentFindingsGeneralDetails.wrongBankAccountType')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesWrongBankAccountNumber) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['wrong-bank-account-number']}
              alt="wrong-bank-account-number-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesWrongBankAccountNumber) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongBankAccountNumber)} ${t('documentFindingsGeneralDetailsSingular.wrongBankAccountNumber')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongBankAccountNumber)} ${t('documentFindingsGeneralDetails.wrongBankAccountNumber')}`}</div>)}
          </div>
      )}
      {Number(documentData.totalOfNoveltiesDuplicateBankAccountNumber) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['duplicate-bank-account-number']}
              alt="empty-bank-account-number-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesDuplicateBankAccountNumber) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesDuplicateBankAccountNumber)} ${t('documentFindingsGeneralDetailsSingular.duplicateBankAccountNumber')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesDuplicateBankAccountNumber)} ${t('documentFindingsGeneralDetails.duplicateBankAccountNumber')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesBankAccountNumberNotRegistered) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['bank-account-number-not-registered']}
              alt="not-registered-bank-account-number-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesBankAccountNumberNotRegistered) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesBankAccountNumberNotRegistered)} ${t('documentFindingsGeneralDetailsSingular.bankAccountNumberNotRegistered')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesBankAccountNumberNotRegistered)} ${t('documentFindingsGeneralDetails.bankAccountNumberNotRegistered')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesWrongDocumentType) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['wrong-document-type']}
              alt="wrong-user-data-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesWrongDocumentType) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongDocumentType)} ${t('documentFindingsGeneralDetailsSingular.wrongDocumentType')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongDocumentType)} ${t('documentFindingsGeneralDetails.wrongDocumentType')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyDocumentNumber) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-document-number']}
              alt="warning-user-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyDocumentNumber) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyDocumentNumber)} ${t('documentFindingsGeneralDetailsSingular.emptyDocumentNumber')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyDocumentNumber)} ${t('documentFindingsGeneralDetails.emptyDocumentNumber')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesWrongDocumentNumber) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['wrong-document-number']}
              alt="wrong-document-number-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesWrongDocumentNumber) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongDocumentNumber)} ${t('documentFindingsGeneralDetailsSingular.wrongDocumentNumber')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongDocumentNumber)} ${t('documentFindingsGeneralDetails.wrongDocumentNumber')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyRegisteredName) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-registered-name']}
              alt="empty-registered-name-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyRegisteredName) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyRegisteredName)} ${t('documentFindingsGeneralDetailsSingular.emptyRegisteredName')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyRegisteredName)} ${t('documentFindingsGeneralDetails.emptyRegisteredName')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesBackgroundResearch) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['background-research']}
              alt="background-research-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesBackgroundResearch) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesBackgroundResearch)} ${t('documentFindingsGeneralDetailsSingular.backgroundResearch')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesBackgroundResearch)} ${t('documentFindingsGeneralDetails.backgroundResearch')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyPaymentAmount) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-payment-amount']}
              alt="empty-payment-amount-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyPaymentAmount) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyPaymentAmount)} ${t('documentFindingsGeneralDetailsSingular.emptyPaymentAmount')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyPaymentAmount)} ${t('documentFindingsGeneralDetails.emptyPaymentAmount')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesWrongPaymentAmount) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['wrong-payment-amount']}
              alt="wrong-payment-amount-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesWrongPaymentAmount) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongPaymentAmount)} ${t('documentFindingsGeneralDetailsSingular.wrongPaymentAmount')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesWrongPaymentAmount)} ${t('documentFindingsGeneralDetails.wrongPaymentAmount')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesEmptyPaymentReference) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['empty-payment-reference']}
              alt="empty-payment-reference-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesEmptyPaymentReference) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyPaymentReference)} ${t('documentFindingsGeneralDetailsSingular.emptyPaymentReference')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesEmptyPaymentReference)} ${t('documentFindingsGeneralDetails.emptyPaymentReference')}`}</div>)}
        </div>
      )}
      {Number(documentData.totalOfNoveltiesDuplicatePaymentReference) > 0 && (
        <div className="document-details-findings-detail-container">
          <div className="document-details-findings-detail-icon">
            <img
              src={getNoveltyIconByType['duplicate-payment-reference']}
              alt="duplicate-payment-reference-registry-icon"
            />
          </div>
          {Number(documentData.totalOfNoveltiesDuplicatePaymentReference) === 1
            ? (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesDuplicatePaymentReference)} ${t('documentFindingsGeneralDetailsSingular.duplicatePaymentReference')}`}</div>)
            : (<div className="document-details-findings-detail-text">{`${Number(documentData.totalOfNoveltiesDuplicatePaymentReference)} ${t('documentFindingsGeneralDetails.duplicatePaymentReference')}`}</div>)}
        </div>
      )}
    </div>
  )
}

export default DocumentFindingsGeneralDetails
